import { FabPieceNote } from './fab-piece-note'
import { FabPieceStep } from './fab-piece-step'

export class FabPiece {
    id!: string
    indexId!: number
    fabJobId!: string
    scope!: string
    markCode?: string | null
    name!: string
    description?: string | null
    quantity!: number
    quantityShipped!: number
    requiredOnSiteDate?: Date | string | null
    priority?: number | null
    estimatedShopHours?: number | null
    unitPrice?: number | null
    isRework!: boolean
    isStock!: boolean
    archived = false
    status!: string
    currentStepId?: string | null
    modifiedDate?: Date | string
    modifiedByUserId?: string
    jobDisplayName?: string
    jobSortOrder?: number
    currentStepName?: string
    currentStepColorHex?: string
    effectiveRequiredOnSiteDate?: Date | string | null
    percentComplete!: number
    nextStepId?: string | null
    nextStepName?: string | null
    nextStepPlannedDate?: Date | string | null
    riskLevel?: string | null
    daysLate?: number | null
    isOnHold!: boolean
    openHoldId?: string | null
    holdReasonName?: string | null
    holdOwnerUserId?: string | null
    holdExpectedReleaseDate?: Date | string | null
    holdDaysOpen?: number | null
    steps: FabPieceStep[] = []
    notes: FabPieceNote[] = []
    imageUrls: string[] = []
    imageFileNames: string[] = []
    drawingFileNames?: string
}
